import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TgGridModule, TgRackModule } from '@trademe/tangram';
import { SummaryPagePropertyInformationSectionComponent } from './summary-page-property-information-section.component';

@NgModule({
    imports: [CommonModule, TgRackModule, TgGridModule, RouterModule],
    declarations: [SummaryPagePropertyInformationSectionComponent],
    exports: [SummaryPagePropertyInformationSectionComponent]
})
export class SummaryPagePropertyInformationSectionModule {}
